import React from "react";

const ArzNimaiiStep = () => {
  return (
    <div className="w-[70%] mx-auto screen800:w-[80%]">
      <div
        className=" w-full mx-auto  text-center my-10
    text-2xl font-bold pb-4
    screen1000:text-xl
    screen800:text-base
    screen600:text-sm  screen1250:pl-8
    screen480:text-xs  
    screen1000:pl-12
    screen800:pl-8
    
    "
      >
        مراحل خرید ارز در سامانه نیما
      </div>
      <div
        className="text-[#4c4c4c]   relative screen600:hidden
      text-xl
      screen1000:text-base
      screen800:text-sm
      screen600:text-xs
      "
      >
        <div style={{ direction: "lrt" }} className="grid grid-cols-7  ">
          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 screen900:w-24 screen900:h-24 screen700:w-24 screen700:h-24  border rounded-full p-1 
           bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div> 1</div>
                <div className="screen1500:text-[13px] screen900:text-[9px] font-bold px-1 ">
                  ثبت سفارش در سامانه نیما
                </div>
              </div>
            </div>
          </div>

          <div className="w-40 screen900:w-20  h-1 bg-[#4c4c4c]  divide-x my-auto mx-auto  -z-10"></div>
          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 screen900:w-24 screen900:h-24 screen700:w-24 screen700:h-24  border rounded-full p-1 
         bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div> 2</div>
                <div className="screen1500:text-[13px] screen900:text-[9px] font-bold  px-1 ">
                  دریافت تاییدیه ثبت سفارش
                </div>
              </div>
            </div>
          </div>
          <div className="w-40 screen900:w-20  h-1 bg-[#4c4c4c]  divide-x my-auto -z-10 "></div>
          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 screen900:w-24 screen900:h-24 screen700:w-24 screen700:h-24  border rounded-full p-1 
          bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div> 3</div>
                <div className="screen1500:text-[13px] screen900:text-[9px] font-bold px-1  ">
                  مراجعه به بانک و ثبت درخواست
                </div>
              </div>
            </div>
          </div>
          <div className="w-40 screen900:w-20  h-1 bg-[#4c4c4c]  divide-x my-auto -z-10 "></div>
          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 screen900:w-24 screen900:h-24 screen700:w-24 screen700:h-24  border rounded-full p-1 
           bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div>4</div>
                <div className="screen1500:text-[13px] screen900:text-[8px] font-bold px-1  ">
                  دریافت گواهی ثبت آماری از بانک
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="w-1 h-40 bg-[#4c4c4c]  divide-y my-auto -z-10 absolute left-20 bottom-28
       screen1500:left-16
       screen900:bottom-10
       screen900:left-12
       screen700:bottom-6
       screen700:left-10
       "
        ></div>

        <div
          style={{ direction: "ltr" }}
          className="grid grid-cols-7 my-20 screen900:my-10 "
        >
          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 screen900:w-24 screen900:h-24 screen700:w-24 screen700:h-24  border rounded-full p-1 
          bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div>8</div>
                <div className="screen1500:text-[13px] screen900:text-[9px] font-bold px-1  ">
                  انتخاب بهترین پیشنهاد
                </div>
              </div>
            </div>
          </div>

          <div className="w-40 screen900:w-20 h-1 bg-[#4c4c4c]  divide-x my-auto -z-10"></div>
          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 screen900:w-24 screen900:h-24 screen700:w-24 screen700:h-24  border rounded-full p-1 
          bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div>7</div>
                <div className="screen1500:text-[13px] screen900:text-[9px] font-bold  px-1 ">
                  بررسی پیشنهاد صرافان
                </div>
              </div>
            </div>
          </div>

          <div className="w-40 screen900:w-20 h-1 bg-[#4c4c4c]  divide-x my-auto -z-10"></div>

          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 screen900:w-24 screen900:h-24 screen700:w-24 screen700:h-24  border rounded-full p-1 
         bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div>6</div>
                <div className="screen1500:text-[13px] screen900:text-[8px] font-bold px-1  ">
                  ورود به سامانه نیما و تکمیل اطلاعات
                </div>
              </div>
            </div>
          </div>
          <div className="w-40 screen900:w-20  h-1 bg-[#4c4c4c]  divide-x my-auto -z-10"></div>

          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 screen900:w-24 screen900:h-24 screen700:w-24 screen700:h-24  border rounded-full p-1 
      bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div>5</div>
                <div className="screen1500:text-[13px] screen900:text-[8px] font-bold  px-1 ">
                  ارائه تعهدات و وثایق لازم به بانک
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="
      w-1 h-40 bg-[#4c4c4c]  divide-y my-auto -z-10 absolute right-16 top-28
      screen1600:right-12
      screen1300:right-9
      screen1100:right-3
     screen900:top-10
     screen800:right-6
     screen750:right-4
     screen700:right-5
     screen650:right-4
      "
        ></div>
        <div style={{ direction: "ltr" }} className="grid grid-cols-7">
          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 screen900:w-24 screen900:h-24 screen700:w-24 screen700:h-24  border rounded-full p-1 
      bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div>9</div>
                <div className="screen1500:text-[13px] screen900:text-[9px] font-bold px-1  ">
                  واریز وجه به حساب صرافی
                </div>
              </div>
            </div>
          </div>
          <div className="w-40 screen900:w-20 h-1 bg-[#4c4c4c]  divide-x my-auto -z-10"></div>
          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 screen900:w-24 screen900:h-24 screen700:w-24 screen700:h-24  border rounded-full p-1 
      bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div>10</div>
                <div className="screen1500:text-[13px] screen900:text-[9px] font-bold px-1  ">
                  ارائه اسناد به بانک
                </div>
              </div>
            </div>
          </div>
          <div className="w-40 screen900:w-20 h-1 bg-[#4c4c4c]  divide-x my-auto -z-10 "></div>
          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 screen900:w-24 screen900:h-24 screen700:w-24 screen700:h-24  border rounded-full p-1 
      bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div>11</div>
                <div className="screen1500:text-[13px] screen900:text-[9px] font-bold  px-1 ">
                  ثبت منشاء ارز
                </div>
              </div>
            </div>
          </div>
          <div className="w-40 screen900:w-20 h-1 bg-[#4c4c4c]  divide-x my-auto -z-10"></div>
          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 screen900:w-24 screen900:h-24 screen700:w-24 screen700:h-24  border rounded-full p-1 
      bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className=" text-center self-center ">
                <div>12</div>
                <div className="screen1500:text-[13px] screen900:text-[9px] font-bold  px-1 ">
                  ترخیص کالا از گمرک
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="text-[#4c4c4c]   relative hidden screen600:grid
      text-xl
      screen1000:text-base
      screen800:text-sm
      screen600:text-xs
      "
      >
        <div style={{ direction: "lrt" }} className="grid grid-cols-5  ">
          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 
            screen900:w-24 screen900:h-24 
            screen470:w-[86px] screen470:h-[86px] 
            screen400:w-[78px] screen400:h-[78px]
            border rounded-full p-1 screen470:p-0.5
           bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div> 1</div>
                <div className="screen1500:text-[13px] screen900:text-[9px] font-bold  screen470:text-[7px] px-2 ">
                  ثبت سفارش در سامانه نیما
                </div>
              </div>
            </div>
          </div>

          <div className="w-40 screen900:w-20 h-1 screen470:h-0.5 bg-[#4c4c4c]  divide-x my-auto mx-auto  -z-10"></div>
          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 
            screen900:w-24 screen900:h-24 
            screen470:w-[84px] screen470:h-[84px]
            screen400:w-[78px] screen400:h-[78px] 
            border rounded-full p-1 screen470:p-0.5
            bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div> 2</div>
                <div className="screen1500:text-[13px] screen900:text-[9px] font-bold  screen470:text-[7px] px-2 ">
                  دریافت تاییدیه ثبت سفارش
                </div>
              </div>
            </div>
          </div>
          <div className="w-40 screen900:w-20 h-1 screen470:h-0.5 bg-[#4c4c4c]  divide-x my-auto -z-10 "></div>
          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 
            screen900:w-24 screen900:h-24 
            screen470:w-[86px] screen470:h-[86px] 
            screen400:w-[78px] screen400:h-[78px]
            border rounded-full p-1 screen470:p-0.5
            bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div> 3</div>
                <div className="screen1500:text-[13px] screen900:text-[9px] font-bold  screen470:text-[7px] px-2 ">
                  مراجعه به بانک و ثبت درخواست
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="w-1 h-28 bg-[#4c4c4c]  divide-y my-auto -z-10 absolute right-8 top-10 screen470:w-0.5
        screen550:right-5
        screen470:right-2
      "
        ></div>

        <div style={{ direction: "ltr" }} className="grid grid-cols-5 my-4">
          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 
            screen900:w-24 screen900:h-24 
            screen470:w-[86px] screen470:h-[86px] 
            screen400:w-[78px] screen400:h-[78px]
            border rounded-full p-1 screen470:p-0.5
            bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div>6</div>
                <div className="screen1500:text-[13px] screen900:text-[9px] font-bold  screen470:text-[6.5px] px-2">
                  ورود به سامانه نیما و تکمیل اطلاعات
                </div>
              </div>
            </div>
          </div>

          <div className="w-40 screen900:w-20 h-1 screen470:h-0.5 bg-[#4c4c4c]  divide-x my-auto -z-10 "></div>

          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 
            screen900:w-24 screen900:h-24 
            screen470:w-[86px] screen470:h-[86px] 
            screen400:w-[78px] screen400:h-[78px]
            border rounded-full p-1 screen470:p-0.5
            bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div>5</div>
                <div className="screen1500:text-[13px] screen900:text-[9px] font-bold  screen470:text-[6.5px] px-2 ">
                  ارائه تعهدات و وثایق لازم به بانک
                </div>
              </div>
            </div>
          </div>
          <div className="w-40 screen900:w-20 h-1 screen470:h-0.5 bg-[#4c4c4c]  divide-x my-auto -z-10"></div>

          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 
            screen900:w-24 screen900:h-24 
            screen470:w-[86px] screen470:h-[86px] 
            screen400:w-[78px] screen400:h-[78px]
            border rounded-full p-1 screen470:p-0.5
            bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div>4</div>
                <div className="screen1500:text-[13px] screen900:text-[9px] font-bold  screen470:text-[6.5px] px-2 ">
                  دریافت گواهی ثبت آماری از بانک
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="w-1 h-28 bg-[#4c4c4c]  divide-y my-auto -z-10 absolute right-8 bottom-10 screen470:w-0.5
        screen550:right-5
        screen470:right-4
        screen400:right-1

       "
        ></div>
        <div style={{ direction: "ltr" }} className="grid grid-cols-5 mb-4">
          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 
            screen900:w-24 screen900:h-24 
            screen470:w-[86px] screen470:h-[86px] 
            screen400:w-[78px] screen400:h-[78px]
            border rounded-full p-1 screen470:p-0.5
            bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div>7</div>
                <div className="screen1500:text-[13px] screen900:text-[9px] font-bold  screen470:text-[7px] px-2 ">
                  بررسی پیشنهاد صرافان
                </div>
              </div>
            </div>
          </div>
          <div className="w-40 screen900:w-20 h-1 screen470:h-0.5 bg-[#4c4c4c]  divide-x my-auto -z-10"></div>
          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 
            screen900:w-24 screen900:h-24 
            screen470:w-[86px] screen470:h-[86px] 
            screen400:w-[78px] screen400:h-[78px]
            border rounded-full p-1 screen470:p-0.5
            bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div>8</div>
                <div className="screen1500:text-[13px] screen900:text-[9px] font-bold  screen470:text-[7px] px-2 ">
                  انتخاب بهترین پیشنهاد
                </div>
              </div>
            </div>
          </div>
          <div className="w-40 screen900:w-20 h-1 screen470:h-0.5 bg-[#4c4c4c]  divide-x my-auto -z-10"></div>

          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 
            screen900:w-24 screen900:h-24 
            screen470:w-[86px] screen470:h-[86px] 
            screen400:w-[78px] screen400:h-[78px]
            border rounded-full p-1 screen470:p-0.5
            bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div>9</div>
                <div className="screen1500:text-[13px] screen900:text-[9px] font-bold  screen470:text-[7px] px-2 ">
                  واریز وجه به حساب صرافی
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="w-1 h-28 bg-[#4c4c4c]  divide-y my-auto -z-10 absolute left-10 bottom-44 screen470:w-0.5
        screen470:bottom-32
        screen470:left-8

       "
        ></div>

        <div style={{ direction: "ltr" }} className="grid grid-cols-5">
          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 
            screen900:w-24 screen900:h-24 
            screen470:w-[86px] screen470:h-[86px] 
            screen400:w-[78px] screen400:h-[78px]
            border rounded-full p-1 screen470:p-0.5
            bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className=" text-center self-center ">
                <div>12</div>
                <div className="screen1500:text-[13px] screen900:text-[9px] font-bold  screen470:text-[7px] px-2 ">
                  ترخیص کالا از گمرک
                </div>
              </div>
            </div>
          </div>

          <div className="w-40 screen900:w-20 h-1 screen470:h-0.5 bg-[#4c4c4c]  divide-x my-auto -z-10 "></div>
          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 
            screen900:w-24 screen900:h-24 
            screen470:w-[86px] screen470:h-[86px]  
            screen400:w-[78px] screen400:h-[78px]
            border rounded-full p-1 screen470:p-0.5
            bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div>11</div>
                <div className="screen1500:text-[13px] screen900:text-[9px] font-bold  screen470:text-[7px] px-2 ">
                  ثبت منشاء ارز
                </div>
              </div>
            </div>
          </div>
          <div className="w-40 screen900:w-20 h-1 screen470:h-0.5 bg-[#4c4c4c]  divide-x my-auto -z-10"></div>

          <div
            className="w-40 h-40 screen1500:w-32 screen1500:h-32 
            screen900:w-24 screen900:h-24 
            screen470:w-[86px] screen470:h-[86px]  
            screen400:w-[78px] screen400:h-[78px]
            border rounded-full p-1 screen470:p-0.5
            bg-gradient-to-r  from-[#BB841B]  via-[#F4EEA0]  to-[#AC7511] border-b-[2px] border-transparent "
          >
            <div className="w-full h-full  rounded-full bg-white my-auto mx-auto grid">
              <div className="w-full text-center self-center ">
                <div>10</div>
                <div className="screen1500:text-[13px] screen900:text-[9px] font-bold  screen470:text-[7px] px-2 ">
                  ارائه اسناد به بانک
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArzNimaiiStep;
